module.exports = __webpack_public_path__ + "static/31-rocket-triangles-d7ea46ef5756ac24fac62844b80cf4ca.png";